import {computed, onBeforeUnmount, onMounted, readonly, ref} from 'vue';

const NAVBAR_HEIGHT_PX = 60;
const HEADER_HEIGHT_OPEN_PX = 110;

export function useHeaderUnloggedScroll() {
    const isCollapsed = ref(false);
    const lastScrollY = ref(0);
    const scrollThreshold = 10; // Minimum scroll distance to trigger hide/show
    const scrollOffsetThreshold = 50; // Minimum scroll from top before collapsing header

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        // Always show topnav when scrolled less than scrollOffsetThreshold from top
        if (currentScrollY < scrollOffsetThreshold) {
            isCollapsed.value = false;
            lastScrollY.value = currentScrollY;
            return;
        }

        // Check scroll direction with threshold to avoid jitter
        const scrollDifference = currentScrollY - lastScrollY.value;

        if (Math.abs(scrollDifference) > scrollThreshold) {
            if (scrollDifference > 0) {
                // Scrolling down - collapse topnav
                isCollapsed.value = true;
            } else {
                // Scrolling up - show topnav
                isCollapsed.value = false;
            }

            lastScrollY.value = currentScrollY;
        }
    };

    onMounted(() => {
        window.addEventListener('scroll', handleScroll, {passive: true});
        handleScroll();
    });
    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });

    const searchBannerStickyTop = computed(() => (isCollapsed.value ? NAVBAR_HEIGHT_PX : HEADER_HEIGHT_OPEN_PX));

    return {
        isCollapsed: readonly(isCollapsed),
        searchBannerStickyTop,
    };
}
